import {defineStore} from "pinia";
import {computed, ref} from "vue";
import {useApiClient} from "@/hooks/api-hook.ts";
import {Charter} from "@/api/client/models/index.ts";
import {DateOnly} from "@microsoft/kiota-abstractions";

export const useCharterCrewBriefingStore = defineStore("charterCrewBriefing", () => {
  const api = useApiClient();

  // State
  const crewBriefing = ref<Charter[]>([]);
  const loading = ref(false);
  const error = ref<string | null>(null);

  // Getters
  const crewBriefingCount = computed(() => crewBriefing.value.length);
  const hasCrewBriefing = computed(() => crewBriefing.value.length > 0);
  const isLoading = computed(() => loading.value);
  const hasError = computed(() => error.value !== null);

  // Actions
  async function fetchCrewBriefing(newDate?: Date) {
    loading.value = true;
    error.value = null;

    try {
      crewBriefing.value = await api.charter.getCrewBriefing.get({queryParameters: {date: new DateOnly({year: newDate.getFullYear(), month: newDate.getMonth() + 1, day: newDate.getDate()})}});
    } catch (err) {
      error.value = err instanceof Error ? err.message : "Failed to fetch crew briefing";
      console.error("Error fetching crew briefing:", err);
    } finally {
      loading.value = false;
    }
  }

  function clearCrewBriefing() {
    crewBriefing.value = [];
    error.value = null;
  }

  function clearError() {
    error.value = null;
  }

  return {
    // State
    crewBriefing,
    loading,
    error,

    // Getters
    crewBriefingCount,
    hasCrewBriefing,
    isLoading,
    hasError,

    // Actions
    fetchCrewBriefing,
    clearCrewBriefing,
    clearError,
  };
});
